import { AllocationEditTabProps } from "features/allocations/edit/AllocationEditTabProps";
import { useAllocationRuleRetrieveSuspense } from "gen/endpoints/allocation-rule/allocation-rule";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const AllocationEditPage: React.FC = () => {
  const { t } = useTranslation(["allocation", "common"]);

  const { allocationRuleId, fundFamilyId } = useRequiredStringParams();
  const { entityId } = useParams();

  const { data: allocationRuleData } = useAllocationRuleRetrieveSuspense(
    fundFamilyId,
    allocationRuleId,
  );

  const entitiesRoute = rootRoute({})
    .fundFamilies({})
    .fundFamily({ fundFamilyId })
    .setup({})
    .entities({});

  const allocationsListRoute = entityId
    ? entitiesRoute.entity({ entityId }).allocations({})
    : entitiesRoute.allocations({});

  const tabContext: AllocationEditTabProps = {
    fundFamilyId,
    allocationRuleId,
  };

  return (
    <PageContent>
      <PageHeader
        title={allocationRuleData.name}
        backButton={{
          title: t("common:allocationRules"),
          path: allocationsListRoute.$,
        }}
      />
      <PageBody>
        <PageTabs context={tabContext} />
      </PageBody>
    </PageContent>
  );
};
